import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { Button } from "@/components/_atoms/button";

import { useDeleteFile } from "../hooks/api/use-delete-file";

interface FileDeleteForm {
  file: {
    id: string;
    name: string;
    ownerId: string;
    ownerType: string;
  };
  onCancel?: () => void;
  onSuccess?: () => void;
}
export const FileDeleteForm: FC<FileDeleteForm> = ({ file, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { deleteFile } = useDeleteFile({ ownerId: file.ownerId, ownerType: file.ownerType });
  const { t } = useTranslation("common");

  async function handleCancelPressed() {
    if (onCancel) {
      onCancel();
    }
  }

  async function handleConfirmationButtonPressed() {
    if (loading) {
      return;
    }

    setLoading(true);
    try {
      await deleteFile({ id: file.id });

      if (onSuccess) {
        toast.success(t("fileDelete.successTitle"), { description: t("fileDelete.successDescription", { name: file.name }) });
        onSuccess();
      }
    } catch (e) {
      toast.error(t("fileDelete.errorTitle"), { description: t("fileDelete.errorDescription") });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className=" sm:max-w-lg">
      <div>
        <span className="text-base font-normal">{t("fileDelete.title")} </span>
      </div>
      <div className="relative max-w-full font-light">
        <p className="mb-2 mt-4 text-xs">
          {t("fileDelete.confirm", { name: file.name })}
        </p>
        <p className="mb-4 text-xs">{t("fileDelete.warning")}</p>
      </div>
      <div className="mt-2 flex flex-row flex-wrap">
        <div className="flex w-full flex-row items-center justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            size="xs"
            onClick={handleCancelPressed}
          >
            {t("actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="xs"
            onClick={handleConfirmationButtonPressed}
          >
            {t("fileDelete.submit")}
          </Button>
        </div>
      </div>
    </div>
  );
};
